(function () {
  'use strict';

  var debounceDelay = 10;
  var collectionImageCache = {};

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getImage(resource) {
    var image = resource.image || resource.featured_image;

    if (!image) {
      return null;
    }

    if (typeof image === 'string') {
      return image;
    }

    return image.url || image.src || null;
  }

  function getCollectionProductsUrl(resource) {
    var collectionUrl = String(resource.url || '').split(/[?#]/)[0].replace(/\/$/, '');

    return collectionUrl ? collectionUrl + '/products.json?limit=1' : null;
  }

  function getCollectionFallbackImage(resource) {
    var url;

    if (getImage(resource)) {
      return Promise.resolve(null);
    }

    url = getCollectionProductsUrl(resource);

    if (!url) {
      return Promise.resolve(null);
    }

    if (!collectionImageCache[url]) {
      collectionImageCache[url] = fetch(url)
        .then(function (response) {
          if (!response.ok) {
            throw new Error(response.status);
          }

          return response.json();
        })
        .then(function (data) {
          var product = data.products && data.products[0];
          var image = product && product.images && product.images[0];

          return image && image.src ? image.src : null;
        })
        .catch(function () {
          return null;
        });
    }

    return collectionImageCache[url].then(function (image) {
      if (image) {
        resource.featured_image = image;
      }
    });
  }

  function addCollectionFallbackImages(collections) {
    return Promise.all(
      collections.map(function (collection) {
        return getCollectionFallbackImage(collection);
      })
    );
  }

  function renderHeading(label, id) {
    return (
      '<div class="predictive-search-title predictive-search-title--group">' +
      '<h4 id="' +
      id +
      '" class="predictive-search-title__content">' +
      escapeHtml(label) +
      '</h4></div>'
    );
  }

  function renderImage(resource, type) {
    var image = getImage(resource);

    if (image) {
      return (
        '<img class="predictive-search-item__image" src="' +
        escapeHtml(image) +
        '" alt="' +
        escapeHtml(resource.title) +
        '">'
      );
    }

    return (
      '<span class="predictive-search-item__image-placeholder predictive-search-item__image-placeholder--' +
      type +
      '" aria-hidden="true"></span>'
    );
  }

  function buildSearchUrl(baseUrl, term) {
    var searchUrl = new URL(baseUrl || '/search', window.location.origin);

    searchUrl.searchParams.set('q', term);
    searchUrl.searchParams.set('type', 'product');
    searchUrl.searchParams.set('options[prefix]', 'last');

    return searchUrl.pathname + searchUrl.search;
  }

  function renderQueries(queries, labels, idPrefix) {
    if (!queries.length) {
      return '';
    }

    return (
      '<section class="predictive-search-group predictive-search-group--queries" aria-labelledby="' +
      idPrefix +
      '-queries">' +
      renderHeading(labels.queries, idPrefix + '-queries') +
      '<ul class="predictive-search__list predictive-search__list--queries" role="listbox" aria-labelledby="' +
      idPrefix +
      '-queries">' +
      queries
        .map(function (query, index) {
          var queryUrl =
            query.url +
            (query.url.indexOf('?') === -1 ? '?' : '&') +
            'type=product&options[prefix]=last';

          return (
            '<li id="' +
            idPrefix +
            '-query-' +
            index +
            '" class="predictive-search-item predictive-search-item--query" role="option" data-dtb-search-result>' +
            '<a class="predictive-search-item__link" href="' +
            escapeHtml(queryUrl) +
            '" tabindex="-1">' +
            '<span class="predictive-search-item__query-icon" aria-hidden="true"></span>' +
            '<span class="predictive-search-item__title-text">' +
            escapeHtml(query.text) +
            '</span></a></li>'
          );
        })
        .join('') +
      '</ul>' +
      '</section>'
    );
  }

  function renderResources(resources, type, label, idPrefix) {
    if (!resources.length) {
      return '';
    }

    return (
      '<section class="predictive-search-group predictive-search-group--' +
      type +
      '" aria-labelledby="' +
      idPrefix +
      '-' +
      type +
      '">' +
      renderHeading(label, idPrefix + '-' + type) +
      '<ul class="predictive-search__list" role="listbox" aria-labelledby="' +
      idPrefix +
      '-' +
      type +
      '">' +
      resources
        .map(function (resource, index) {
          return (
            '<li id="' +
            idPrefix +
            '-' +
            type +
            '-' +
            index +
            '" class="predictive-search-item" role="option" data-dtb-search-result>' +
            '<a class="predictive-search-item__link" href="' +
            escapeHtml(resource.url) +
            '" tabindex="-1">' +
            '<span class="predictive-search__column predictive-search__column--image">' +
            renderImage(resource, type) +
            '</span>' +
            '<span class="predictive-search__column predictive-search__column--content predictive-search__column--center">' +
            '<span class="predictive-search-item__title-text">' +
            escapeHtml(resource.title) +
            '</span></span></a></li>'
          );
        })
        .join('') +
      '</ul>' +
      '</section>'
    );
  }

  function renderResults(results, term, labels, idPrefix, searchUrl) {
    return (
      '<div class="predictive-search">' +
      '<div class="predictive-search-title predictive-search-title--main">' +
      '<h3 id="' +
      idPrefix +
      '-title" class="predictive-search-title__content">' +
      escapeHtml(labels.suggestions) +
      '</h3></div>' +
      renderQueries((results.queries || []).slice(0, 4), labels, idPrefix) +
      renderResources(
        (results.collections || []).slice(0, 3),
        'collections',
        labels.collections,
        idPrefix
      ) +
      renderResources(
        (results.products || []).slice(0, 6),
        'products',
        labels.products,
        idPrefix
      ) +
      '<ul class="predictive-search__list predictive-search__list--view-all" role="listbox" aria-labelledby="' +
      idPrefix +
      '-title"><li class="predictive-search-view-all" role="option" data-dtb-search-result>' +
      '<a class="predictive-search-view-all__link" href="' +
      escapeHtml(searchUrl) +
      '" tabindex="-1">' +
      escapeHtml(labels.viewAll) +
      '<span class="predictive-search-view-all__query"> &ldquo;' +
      escapeHtml(term) +
      '&rdquo;</span></a></li></ul></div>'
    );
  }

  function renderLoadingState(loadingText) {
    return (
      '<div class="predictive-search">' +
      '<div class="predictive-search-loading">' +
      '<span class="visually-hidden">' +
      escapeHtml(loadingText || 'Loading') +
      '</span>' +
      '<span class="predictive-search-loading__icon">' +
      '<span class="icon-predictive-search-spinner"></span>' +
      '</span>' +
      '</div>' +
      '</div>'
    );
  }

  function initPredictiveSearch(container, index) {
    var input = container.querySelector('[data-dtb-predictive-search-input]');
    var resultsNode = container.querySelector('[data-dtb-predictive-search-results]');
    var clearButton = container.querySelector('[data-dtb-predictive-search-clear]');
    var form = input && input.form;
    var timer;
    var controller;
    var resultsCache = {};
    var selectedIndex = -1;
    var idPrefix = 'dtb-predictive-search-' + index;
    var labels = {
      suggestions: container.dataset.labelSuggestions,
      queries: container.dataset.labelQueries,
      products: container.dataset.labelProducts,
      collections: container.dataset.labelCollections,
      viewAll: container.dataset.labelViewAll,
      loading: container.dataset.labelLoading
    };

    if (!input || !resultsNode || !form) {
      return;
    }

    input.setAttribute('aria-controls', idPrefix + '-results');
    input.setAttribute('autocomplete', 'off');
    resultsNode.id = idPrefix + '-results';

    function cancelPendingLoad() {
      window.clearTimeout(timer);
      timer = null;

      if (controller) {
        controller.abort();
        controller = null;
      }
    }

    function close() {
      cancelPendingLoad();
      resultsNode.classList.remove('predictive-search-wrapper--visible');
      resultsNode.innerHTML = '';
      resultsNode.removeAttribute('aria-busy');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      selectedIndex = -1;
    }

    function getOptions() {
      return resultsNode.querySelectorAll('[data-dtb-search-result]');
    }

    function getCacheKey(term) {
      return term.toLowerCase();
    }

    function showResults(results, term) {
      var searchUrl = buildSearchUrl(input.dataset.baseUrl || '/search', term);
      var renderedResults = renderResults(results, term, labels, idPrefix, searchUrl);

      resultsCache[getCacheKey(term)] = renderedResults;
      resultsNode.innerHTML = renderedResults;
      resultsNode.classList.add('predictive-search-wrapper--visible');
      resultsNode.removeAttribute('aria-busy');
      input.setAttribute('aria-expanded', 'true');
      selectedIndex = -1;
    }

    function showCachedResults(term) {
      var cachedResults = resultsCache[getCacheKey(term)];

      if (!cachedResults) {
        return false;
      }

      resultsNode.innerHTML = cachedResults;
      resultsNode.classList.add('predictive-search-wrapper--visible');
      resultsNode.removeAttribute('aria-busy');
      input.setAttribute('aria-expanded', 'true');
      selectedIndex = -1;

      return true;
    }

    function showLoadingState() {
      resultsNode.innerHTML = renderLoadingState(labels.loading);
      resultsNode.classList.add('predictive-search-wrapper--visible');
      resultsNode.setAttribute('aria-busy', 'true');
      input.setAttribute('aria-expanded', 'true');
      input.removeAttribute('aria-activedescendant');
      selectedIndex = -1;
    }

    function selectOption(nextIndex) {
      var options = getOptions();

      if (!options.length) {
        return;
      }

      if (selectedIndex >= 0 && options[selectedIndex]) {
        options[selectedIndex].classList.remove('predictive-search-item--selected');
        options[selectedIndex].removeAttribute('aria-selected');
      }

      selectedIndex = (nextIndex + options.length) % options.length;
      options[selectedIndex].classList.add('predictive-search-item--selected');
      options[selectedIndex].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', options[selectedIndex].id || '');
    }

    function loadResults(term) {
      var baseUrl = input.dataset.baseUrl || '/search';
      var requestController;
      var url =
        baseUrl +
        '/suggest.json?q=' +
        encodeURIComponent(term) +
        '&resources[type]=query,product,collection' +
        '&resources[limit]=6' +
        '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last';

      if (controller) {
        controller.abort();
      }

      controller = new AbortController();
      requestController = controller;

      fetch(url, { signal: requestController.signal })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(response.status);
          }

          return response.json();
        })
        .then(function (data) {
          var resources = data.resources.results;

          return addCollectionFallbackImages(
            (resources.collections || []).slice(0, 3)
          ).then(function () {
            if (requestController.signal.aborted) {
              return;
            }

            if (input.value.trim() !== term) {
              return;
            }

            showResults(resources, term);
          });
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') {
            close();
          }
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();

      cancelPendingLoad();

      if (!term) {
        close();
        return;
      }

      if (showCachedResults(term)) {
        timer = window.setTimeout(function () {
          loadResults(term);
        }, debounceDelay);
        return;
      }

      showLoadingState();

      timer = window.setTimeout(function () {
        loadResults(term);
      }, debounceDelay);
    });

    input.addEventListener('focus', function () {
      var term = input.value.trim();
      var isOpen = resultsNode.classList.contains('predictive-search-wrapper--visible');

      if (term && !isOpen) {
        if (!showCachedResults(term)) {
          showLoadingState();
          loadResults(term);
        }
      }
    });

    input.addEventListener('keydown', function (event) {
      var options = getOptions();

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        selectOption(selectedIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        selectOption(selectedIndex - 1);
      } else if (event.key === 'Enter') {
        if (selectedIndex >= 0 && options[selectedIndex]) {
          event.preventDefault();
          cancelPendingLoad();
          options[selectedIndex].querySelector('a, button').click();
          return;
        }

        cancelPendingLoad();
        close();
      } else if (event.key === 'Escape') {
        close();
      }
    });

    form.addEventListener('submit', function () {
      close();
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        cancelPendingLoad();
        window.setTimeout(close, 0);
      });
    }

    document.addEventListener('click', function (event) {
      if (!container.contains(event.target)) {
        close();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('[data-dtb-predictive-search]')
      .forEach(initPredictiveSearch);
  });
})();
